var _defs, _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebAccessibilityBody(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Artwork",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#036;}.cls-2{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 75,
    cy: 75,
    r: 75
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 75,
    cy: 38.51,
    r: 10.13
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M85.57,67.31l22.21-6.12a5.36,5.36,0,0,0,3.77-6.61h0a5.44,5.44,0,0,0-6.68-3.73L80.51,57.64a18,18,0,0,1-11,0L45.13,50.85a5.44,5.44,0,0,0-6.68,3.73h0a5.36,5.36,0,0,0,3.77,6.61l22.21,6.12a4.05,4.05,0,0,1,3,3.89v7.31a23.62,23.62,0,0,1-2.36,10.31L53.14,113.48a5.33,5.33,0,0,0,2.55,7.15h0a5.44,5.44,0,0,0,7.23-2.53L75,93.2l12.12,24.9a5.44,5.44,0,0,0,7.23,2.53h0a5.33,5.33,0,0,0,2.55-7.15L85,88.82a23.62,23.62,0,0,1-2.36-10.31V71.2A4.05,4.05,0,0,1,85.57,67.31Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebAccessibilityBody);
export default __webpack_public_path__ + "static/media/web-accessibility-body.1e30e1f98eba9041eaa1918a54f911f8.svg";
export { ForwardRef as ReactComponent };